/**
 * --------------------------------------------------------------------------
 * Styles (Imported on scss file)
 * --------------------------------------------------------------------------
 */

import './frontend-sources/scss/site.scss';

/**
 * --------------------------------------------------------------------------
 * jQuery
 * --------------------------------------------------------------------------
 */

import $ from 'jquery';

window.jQuery = $;
window.$ = $;
window.jquery = $;

/**
 * --------------------------------------------------------------------------
 * Bootstrap
 * --------------------------------------------------------------------------
 */

import 'popper.js';
// import 'bootstrap';
// Alternatively, you may import plugins individually as needed:
// import 'bootstrap/js/dist/util';
// import 'bootstrap/js/dist/alert';
import 'bootstrap/js/dist/collapse'; // Required by Accordion Block
import 'bootstrap/js/dist/tooltip'; // Required by: Accordion Block
import 'bootstrap/js/dist/dropdown'; // Required by: Main navigation
import 'bootstrap/js/dist/button'; // Required by: Main navigation
import 'bootstrap/js/dist/modal'; // Required by: Cookie Consent

/**
 * --------------------------------------------------------------------------
 * Custom
 * --------------------------------------------------------------------------
 */

/* Global */
import './frontend-sources/js/navbar';
import './frontend-sources/js/lazyload';
import './frontend-sources/js/table-responsive';
import './frontend-sources/js/ofi';
import './frontend-sources/js/bsFrontEndValidator';
import './frontend-sources/js/search';

/* Blocks */
import './Features/Blocks/HeroBlock/HeroBlock';
import './Features/Blocks/YouTubeBlock/YouTubeBlock';
import './Features/Blocks/AccordionBlock/AccordionBlock';
import './Features/Blocks/CharityBlock/CharityBlock';
import './Features/Blocks/SegmentPollBlock/SegmentPollBlock';